
import { useState, useEffect } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AdminHeader } from "@/components/admin/AdminHeader";
import { AdminUsersList } from "@/components/admin/AdminUsersList";
import { DiagnosticsContent } from "@/components/admin/diagnostics/DiagnosticsContent";
import { CompanyLinkingTool } from "@/components/admin/CompanyLinkingTool";
import EmailLogsTab from "@/components/admin/EmailLogs/EmailLogsTab";
import { Helmet } from "react-helmet-async";
import { supabase } from "@/integrations/supabase/client";
import { useDiagnostics } from "@/components/admin/diagnostics/useDiagnostics";
import { toast } from "sonner";

const Admin2 = () => {
  // State for user management
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);
  
  // Use the diagnostics hook to get diagnostic results
  const { results, loading: loadingDiagnostics, runDiagnostics } = useDiagnostics();
  
  // Fetch users for the AdminUsersList
  const fetchUsers = async () => {
    try {
      setLoadingUsers(true);
      const { data, error } = await supabase.rpc('get_users_for_admin');
      
      if (error) {
        throw error;
      }
      
      setUsers(data || []);
    } catch (error: any) {
      console.error("Error fetching users:", error);
      toast.error(`Failed to load users: ${error.message}`);
      setUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  // Initial data load
  useEffect(() => {
    fetchUsers();
    runDiagnostics();
  }, []);
  
  return (
    <div className="container mx-auto py-4 space-y-6">
      <Helmet>
        <title>Admin Dashboard | CRM</title>
      </Helmet>
      
      <AdminHeader />
      
      <Tabs defaultValue="users">
        <TabsList className="w-full border-b mb-4">
          <TabsTrigger value="users">Users</TabsTrigger>
          <TabsTrigger value="diagnostics">System Diagnostics</TabsTrigger>
          <TabsTrigger value="tools">Data Tools</TabsTrigger>
          <TabsTrigger value="email-logs">Email Logs</TabsTrigger>
        </TabsList>
        
        <TabsContent value="users">
          <AdminUsersList 
            users={users} 
            onUserUpdated={fetchUsers}
          />
        </TabsContent>
        
        <TabsContent value="diagnostics">
          <DiagnosticsContent results={results} />
        </TabsContent>
        
        <TabsContent value="tools">
          <div className="space-y-6">
            <CompanyLinkingTool />
          </div>
        </TabsContent>
        
        <TabsContent value="email-logs">
          <EmailLogsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Admin2;
